export default __webpack_public_path__ + "static/media/technical-recruitment.3dd40b28.jpg";